import {useQuery} from '@apollo/client';

import type {CurrentUserAiCreditUsageQuery} from '../__generated/CurrentUserAiCreditUsageQuery';
import {CURRENT_USER_AI_CREDIT_USAGE_QUERY} from '../ModelHubQueries';

export interface CurrentUserAiCreditUsage {
  creditsGranted: number | null;
  creditsUsed: number | null;
  hasEntitlement: boolean;
}

export interface UseCurrentUserAiCreditUsageResult {
  hasError: boolean;
  isLoading: boolean;
  usage: CurrentUserAiCreditUsage | null;
}

export function useCurrentUserAiCreditUsage(): UseCurrentUserAiCreditUsageResult {
  const {data, error, loading} = useQuery<CurrentUserAiCreditUsageQuery>(CURRENT_USER_AI_CREDIT_USAGE_QUERY);

  return {
    hasError: error != null,
    isLoading: loading,
    usage: data?.currentUserAiCreditUsage ?? null,
  };
}
